import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usdCurrencyMask',
  standalone: false
})
export class UsdCurrencyMaskPipe implements PipeTransform {
  transform(value: any, includeSymbol: boolean = false): string {
    if (value == null || isNaN(value)) return '';

    return Number(value).toLocaleString('en-US', {
      style: includeSymbol ? 'currency' : 'decimal',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}